import { Button, makeStyles, mergeClasses, Tooltip } from '@fluentui/react-components';
import React, { useCallback } from 'react';
import {
  CodeTextEditRegular,
  DismissCircleRegular,
  DocumentTextRegular,
  SaveRegular,
} from '@fluentui/react-icons';
import { useExportTranscriptMutation } from '../../queries/recording';

const useStyles = makeStyles({
  wrapperStyle: {
    display: 'flex',
    flex: 1,
    gap: '10px',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
  },
});

export const MeetingTranscriptActionsBar = (props: {
  className?: string;
  recordingId: string;
  isEditing: boolean;
  hasAnyPendingEdit: boolean;
  startEditing: () => void;
  cancelEditing: () => void;
  saveEditing: () => void;
  editable: boolean;
  transcriptExpired?: boolean;
}) => {
  const {
    className,
    recordingId,
    startEditing,
    isEditing,
    cancelEditing,
    saveEditing,
    hasAnyPendingEdit,
    editable,
    transcriptExpired,
  } = props;

  const { mutateAsync: doExport, isPending: isExporting } =
    useExportTranscriptMutation();

  const exportTranscript = useCallback(async () => {
    const file = await doExport(recordingId);
    const url = window.URL.createObjectURL(file);

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${recordingId}_transcription.docx`);
    document.body.appendChild(link);
    link.click();
    link.parentNode?.removeChild(link);
  }, [doExport, recordingId]);

  const styles = useStyles();

  return (
    <div
      className={
        className
          ? mergeClasses(styles.wrapperStyle, className)
          : styles.wrapperStyle
      }
    >
      {isEditing ? (
        <>
          <Button
            appearance="subtle"
            aria-label="cancel"
            icon={<DismissCircleRegular />}
            onClick={cancelEditing}
          >
            Annuler
          </Button>
          <Button
            appearance="primary"
            aria-label="save"
            icon={<SaveRegular />}
            onClick={saveEditing}
            disabled={hasAnyPendingEdit}
          >
            Sauvegarder
          </Button>
        </>
      ) : (
        <>
          {editable && !transcriptExpired && (
            <Button
              appearance="secondary"
              aria-label="edit"
              icon={<CodeTextEditRegular />}
              onClick={startEditing}
            >
              Mode édition
            </Button>
          )}
          {transcriptExpired ? (
            <Tooltip
              content="Transcription supprimée après 3 mois — export indisponible."
              relationship="label"
            >
              <Button
                appearance="secondary"
                aria-label="export"
                icon={<DocumentTextRegular />}
                disabled
              >
                Exporter
              </Button>
            </Tooltip>
          ) : (
            <Button
              appearance="secondary"
              aria-label="export"
              icon={<DocumentTextRegular />}
              onClick={exportTranscript}
              disabled={isExporting}
            >
              Exporter
            </Button>
          )}
        </>
      )}
    </div>
  );
};
